import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { StateCreator } from 'zustand/vanilla';

import { createSelectors } from '@/libs/zustand';
import { StorageStoreDefault } from '@/models/store';
import { EncryptedStorage } from '@/utils/storage';

import { StoreMarket } from '../types/market';

export const MARKET_PERSIST_KEY = 'abonoComMarket';

export interface MarketState {
    market?: StoreMarket;
}

interface MarketActions {
    setMarket: (market: NonNullable<MarketState['market']>) => void;
    resetMarket: () => void;
}

type StateAndActions = MarketState & MarketActions & StorageStoreDefault;

const store: StateCreator<StateAndActions> = (set) => ({
    market: undefined,
    isStorageLoaded: false,

    setMarket: ({ id, name, currencyCode, currencySymbol }) =>
        set((state) =>
            state.market?.id !== id ||
            state.market?.name !== name ||
            state.market?.currencyCode !== currencyCode ||
            state.market?.currencySymbol !== currencySymbol
                ? { market: { id, name, currencyCode, currencySymbol } }
                : state,
        ),
    resetMarket: () => set((state) => (state.market !== undefined ? { market: undefined } : state)),
    setIsStorageLoaded: () => set((state) => (!state.isStorageLoaded ? { isStorageLoaded: true } : state)),
});

const useMarketStoreBase = create<StateAndActions>()(
    persist(immer<StateAndActions>(store), {
        name: MARKET_PERSIST_KEY,
        partialize: ({ market }) => ({ market }),
        storage: new EncryptedStorage(),
        onRehydrateStorage: () => (state) => {
            state?.setIsStorageLoaded();
        },
    }),
);

export const useMarketStore = createSelectors(useMarketStoreBase);
